import A from 'utils/metrics/analytic'

const A_TG_Click = (path: string) => {
  A.setEvent('banner_click', { page_path: path, name: 'tg_bot' })
}

const A_TG_Show = (path: string) => {
  A.setEvent('banner_shown', { page_path: path, name: 'tg_bot' })
}

export { A_TG_Click, A_TG_Show }
